module.exports = [
  { key: '156',	name: '中国' },
  { key: '344',	name: '香港' },
  { key: '446',	name: '澳门' },
  { key: '158',	name: '台湾' },
  { key: '004',	name: '阿富汗' },
  { key: '008',	name: '阿尔巴尼亚' },
  { key: '010',	name: '南极洲' },
  { key: '012',	name: '阿尔及利亚' },
  { key: '016',	name: '美属萨摩亚' },
  { key: '020',	name: '安道尔' },
  { key: '024',	name: '安哥拉' },
  { key: '028',	name: '安提瓜与巴布达' },
  { key: '031',	name: '阿塞拜疆' },
  { key: '032',	name: '阿根廷' },
  { key: '036',	name: '澳大利亚' },
  { key: '040',	name: '奥地利' },
  { key: '044',	name: '巴哈马' },
  { key: '048',	name: '巴林' },
  { key: '050',	name: '孟加拉国' },
  { key: '051',	name: '亚美尼亚' },
  { key: '052',	name: '巴巴多斯' },
  { key: '056',	name: '比利时' },
  { key: '060',	name: '百慕大' },
  { key: '064',	name: '不丹' },
  { key: '068',	name: '玻利维亚' },
  { key: '070',	name: '波黑' },
  { key: '072',	name: '博茨瓦纳' },
  { key: '074',	name: '布维岛' },
  { key: '076',	name: '巴西' },
  { key: '084',	name: '伯利兹' },
  { key: '086',	name: '英属印度洋领地' },
  { key: '090',	name: '所罗门群岛' },
  { key: '092',	name: '英属维尔京群岛' },
  { key: '096',	name: '文莱' },
  { key: '100',	name: '保加利亚' },
  { key: '104',	name: '缅甸' },
  { key: '108',	name: '布隆迪' },
  { key: '112',	name: '白俄罗斯' },
  { key: '116',	name: '柬埔寨' },
  { key: '120',	name: '喀麦隆' },
  { key: '124',	name: '加拿大' },
  { key: '132',	name: '佛得角' },
  { key: '136',	name: '开曼群岛' },
  { key: '140',	name: '中非' },
  { key: '144',	name: '斯里兰卡' },
  { key: '148',	name: '乍得' },
  { key: '152',	name: '智利' },
  { key: '162',	name: '圣诞岛' },
  { key: '166',	name: '科科斯(基林)群岛' },
  { key: '170',	name: '哥伦比亚' },
  { key: '174',	name: '科摩罗' },
  { key: '175',	name: '马约特' },
  { key: '178',	name: '刚果(布)' },
  { key: '180',	name: '刚果(金)' },
  { key: '184',	name: '库克群岛' },
  { key: '188',	name: '哥斯达黎加' },
  { key: '191',	name: '克罗地亚' },
  { key: '192',	name: '古巴' },
  { key: '196',	name: '塞浦路斯' },
  { key: '203',	name: '捷克' },
  { key: '204',	name: '贝宁' },
  { key: '208',	name: '丹麦' },
  { key: '212',	name: '多米尼克' },
  { key: '214',	name: '多米尼加' },
  { key: '218',	name: '厄瓜多尔' },
  { key: '222',	name: '萨尔瓦多' },
  { key: '226',	name: '赤道几内亚' },
  { key: '231',	name: '埃塞俄比亚' },
  { key: '232',	name: '厄立特里亚' },
  { key: '233',	name: '爱沙尼亚' },
  { key: '234',	name: '法罗群岛' },
  { key: '238',	name: '福克兰群岛(马尔维纳斯)' },
  { key: '239',	name: '南乔治亚岛和南桑德韦奇岛' },
  { key: '242',	name: '斐济' },
  { key: '246',	name: '芬兰' },
  { key: '250',	name: '法国' },
  { key: '254',	name: '法属圭亚那' },
  { key: '258',	name: '法属波利尼西亚' },
  { key: '260',	name: '法属南部领地' },
  { key: '262',	name: '吉布提' },
  { key: '266',	name: '加蓬' },
  { key: '268',	name: '格鲁吉亚' },
  { key: '270',	name: '冈比亚' },
  { key: '275',	name: '巴勒斯坦' },
  { key: '276',	name: '德国' },
  { key: '288',	name: '加纳' },
  { key: '292',	name: '直布罗陀' },
  { key: '296',	name: '基里巴斯' },
  { key: '300',	name: '希腊' },
  { key: '304',	name: '格陵兰' },
  { key: '308',	name: '格林纳达' },
  { key: '312',	name: '瓜德罗普' },
  { key: '316',	name: '关岛' },
  { key: '320',	name: '危地马拉' },
  { key: '324',	name: '几内亚' },
  { key: '328',	name: '圭亚那' },
  { key: '332',	name: '海地' },
  { key: '334',	name: '赫德岛和麦克唐纳岛' },
  { key: '336',	name: '梵蒂冈' },
  { key: '340',	name: '洪都拉斯' },
  { key: '348',	name: '匈牙利' },
  { key: '352',	name: '冰岛' },
  { key: '356',	name: '印度' },
  { key: '360',	name: '印度尼西亚' },
  { key: '364',	name: '伊朗' },
  { key: '368',	name: '伊拉克' },
  { key: '372',	name: '爱尔兰' },
  { key: '376',	name: '以色列' },
  { key: '380',	name: '意大利' },
  { key: '384',	name: '科特迪瓦' },
  { key: '388',	name: '牙买加' },
  { key: '392',	name: '日本' },
  { key: '398',	name: '哈萨克斯坦' },
  { key: '400',	name: '约旦' },
  { key: '404',	name: '肯尼亚' },
  { key: '408',	name: '朝鲜' },
  { key: '410',	name: '韩国' },
  { key: '414',	name: '科威特' },
  { key: '417',	name: '吉尔吉斯斯坦' },
  { key: '418',	name: '老挝' },
  { key: '422',	name: '黎巴嫩' },
  { key: '426',	name: '莱索托' },
  { key: '428',	name: '拉脱维亚' },
  { key: '430',	name: '利比里亚' },
  { key: '434',	name: '利比亚' },
  { key: '438',	name: '列支敦士登' },
  { key: '440',	name: '立陶宛' },
  { key: '442',	name: '卢森堡' },
  { key: '450',	name: '马达加斯加' },
  { key: '454',	name: '马拉维' },
  { key: '458',	name: '马来西亚' },
  { key: '462',	name: '马尔代夫' },
  { key: '466',	name: '马里' },
  { key: '470',	name: '马耳他' },
  { key: '474',	name: '马提尼克' },
  { key: '478',	name: '毛里塔尼亚' },
  { key: '480',	name: '毛里求斯' },
  { key: '484',	name: '墨西哥' },
  { key: '492',	name: '摩纳哥' },
  { key: '496',	name: '蒙古' },
  { key: '498',	name: '摩尔多瓦' },
  { key: '500',	name: '蒙特塞拉特' },
  { key: '504',	name: '摩洛哥' },
  { key: '508',	name: '莫桑比克' },
  { key: '512',	name: '阿曼' },
  { key: '516',	name: '纳米比亚' },
  { key: '520',	name: '瑙鲁' },
  { key: '524',	name: '尼泊尔' },
  { key: '528',	name: '荷兰' },
  { key: '530',	name: '荷属安的列斯' },
  { key: '533',	name: '阿鲁巴' },
  { key: '540',	name: '新喀里多尼亚' },
  { key: '548',	name: '瓦努阿图' },
  { key: '554',	name: '新西兰' },
  { key: '558',	name: '尼加拉瓜' },
  { key: '562',	name: '尼日尔' }
]


// WEBPACK FOOTER //
// ./src/config/dict/nationality.js